import styled from 'styled-components';

import ThinCrossIcon from '#/assets/ThinCrossIcon';

import { cFFFFFF } from '#/colors';

import BaseModal, { ModalProps } from '#/components/common/modal';

const MODAL_TITLE_ID = 'wallet-modal-title';

export function Modal(props: ModalProps) {
  return (
    <BaseModal {...props} aria-labelledby={MODAL_TITLE_ID}>
      <div css="display: grid; gap: 16px;">{props.children}</div>
    </BaseModal>
  );
}

export const ModalHeader = styled.div`
  display: grid;
  gap: 12px;
  grid-template-columns: 1fr auto;
  align-items: start;
`;

export const ModalTitle = styled.h1.attrs({ id: MODAL_TITLE_ID })`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 700;
  line-height: 19px;
  margin: 0;
`;

export const ModalCloseButton = styled.button.attrs({
  children: <ThinCrossIcon size={14} />,
  type: 'button',
  'aria-label': 'Close',
})`
  padding: 0;
  background: none;
  border: none;
  color: ${cFFFFFF};
`;
